import {
    SAVE_ADDRESS,
    GET_ADDRESSLIST,
    DELETE_ADDRESS,
    LOAD_ADDRESS,
    UPDATE_ADDRESS
} from '../actions/types'



const initialState = {
    editAddressStatus: false
}


export default function (state = initialState, action) {

    switch (action.type) {
        case SAVE_ADDRESS:
            return {
                ...state,
                saveAddressResponse: action.payload
            }
        case GET_ADDRESSLIST:
            return {
                ...state,
                getAddressListResponse: action.payload
            }
        case DELETE_ADDRESS:
            return {
                ...state,
                deleteAddressResponse: action.payload
            }
        case LOAD_ADDRESS:
            return {
                ...state,
                loadAddress: action.payload,
                editAddressStatus: !!action.payload ? true : false
            }
        case UPDATE_ADDRESS:
            return {
                ...state,
                updateAddressResponse: action.payload,

            }
        default:
            return state
    }
} 